import { Button, Modal, Typography } from '@orijinworks/frontend-commons';
import React from 'react';
import styles from './picture-viewer.style';
import { withStyles } from '@material-ui/styles';
import { usePictureViewerHook } from './usePictureViewerHook';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const PictureViewer = (props) => {
    const { classes } = props;
    const { videoContactDetails, isLoading, modalRef, toggleModal } = usePictureViewerHook(props);

    return (
        <>
            <Button
                onClick={toggleModal}
                className={classes.button}>
                View Photo
            </Button>
            <Modal
                showFooter={false}
                open={false}
                ref={modalRef}
                onClose={toggleModal}
                heading={`${videoContactDetails?.firstName} ${videoContactDetails?.lastName} Photo`}
                modalType={{
                    size: 'medium',
                    type: 'info'
                }}
            >
                <Box display="flex" flexDirection="column">
                    <Typography
                        className={classes.photoHeading}
                        variant="overlineLarge">
                        Contact Photo
                    </Typography>
                    {isLoading && (
                        <Skeleton variant="rectangular" className={classes.imgContainer} />
                    )}
                    {!isLoading && (
                        <Box component="img" src={videoContactDetails?.idDocumentUrl} className={classes.imgContainer} />
                    )}
                </Box>
            </Modal>
        </>
    );
};


export default withStyles(styles)(PictureViewer);
